import { pgTable, uuid, varchar, jsonb, text, timestamp } from "drizzle-orm/pg-core";

// ============================================================================
// AUDIT TRAIL (SPRINT-6C F007, updated SPRINT-A-EDG-319 F002) - 1 table
// Append-only audit log for sensitive CRM tables
//
// SPRINT-A-EDG-319 F002 changes:
//   - userId: uuid("user_id") → text("user_id")  (Clerk IDs are strings, not UUIDs)
//   - renderedText: new TEXT column for materialised formatter prose (backfilled in F010)
// ============================================================================

export const crmXAuditTrail = pgTable("crm_x_audit_trail", {
  id: uuid("id").primaryKey().defaultRandom(),
  tableName: varchar("table_name", { length: 255 }).notNull(),
  recordId: uuid("record_id").notNull(),
  action: varchar("action", { length: 10 }).notNull(),
  oldData: jsonb("old_data"),
  newData: jsonb("new_data"),
  changedFields: text("changed_fields").array(),
  userId: text("user_id"),
  userEmail: varchar("user_email", { length: 255 }),
  ipAddress: varchar("ip_address", { length: 45 }),
  renderedText: text("rendered_text"),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow(),
});
